export default "__VITE_ASSET__D7ZMb6K9__"